import {useState} from 'react';
import {Button, Select} from 'antd';

export const MovePlantWidget = ({rows, onMove, disabled, props}) => {
    const [active, setActive] = useState(false);

    const onButtonClick = () => {
        setActive(true);
    }

    const rowOptions = rows.map(r => {
        const {id: value, rowName: label} = r;
        return {
            value,
            label
        }
    })

    const onChange = (val) => {
        console.log(`changed to ${val}`)
        if (onMove) {
            onMove(val)
        }
        setActive(false)
    }

    const onBlur = () => {
        setActive(false);
    }

    if (active) {
        return <Select placeholder={`Select Row`} options={rowOptions} onChange={onChange} onBlur={onBlur} popupMatchSelectWidth={false}/>
    } else {
        return <div>
            <Button onClick={onButtonClick} disabled={disabled}>
                Move
            </Button>
        </div>
    }
}